export default function needs(props) {
    return {
        name: `needs`,
        title: 'Mortgage needs',
        link: `apply/needs`,
        personalisedTitle:'your mortgage needs',
        props: props,
        questions: [
            circumstanceChanges(props),
            circumstanceChangesDetails(props),
            healthIssues(props),
            healthIssuesDetails(props),
            policeRecord(props),
            policeRecordDetails(props),
            incomeChange(props),
            expenditureChange(props),
            moveLikely(props),
            plannedPayOff(props),
            beyondRetirement(props),
            speedEssential(props),
            consolidatingDebt(props),
            furtherRequirements(props),
            furtherRequirementsDetails(props),
        ]
    }
}
export function circumstanceChanges(props) {
    return {
        label: "Circumstance Changes",
        text: "Are you aware of any known future changes to your circumstances which may affect your ability to repay the proposed mortgage?",
        name: "circumstanceChanges",
        answer: {
            type: "choice",
            choices: [
                {
                    text: "Yes",
                    value: true
                },
                {
                    text: "No",
                    value: false
                }
            ]
        },
        model: "needs"
    }
}
export function circumstanceChangesDetails(props) {
    return {
        label: "Circumstance Changes Details",
        text: "Supply some details about this",
        name: "circumstanceChangesDetails",
        answer: {
            type: "textarea"
        },
        hides: {
            circumstanceChanges: (v) => {
                return v !== true
            }
        },
        model: "needs"
    }
}
export function healthIssues(props) {
    return {
        label: "Health Issues",
        text: "Are you aware of any health issues that may affect your ability to work and meet the repayments of this facility?",
        name: "healthIssues",
        answer: {
            type: "choice",
            choices: [
                {
                    text: "Yes",
                    value: true
                },
                {
                    text: "No",
                    value: false
                }
            ]
        },
        model: "needs"
    }
}
export function healthIssuesDetails(props) {
    return {
        label: "Health Issues Details",
        text: "Supply some details about this",
        name: "healthIssuesDetails",
        answer: {
            type: "textarea"
        },
        hides: {
            healthIssues: (v) => {
                return v !== true
            }
        },
        model: "needs"
    }
}
export function policeRecord(props) {
    return {
        name: "policeRecord",
        answer: {
            type: "choice",
            choices: [
                {
                    text: "Yes",
                    value: true
                },
                {
                    text: "No",
                    value: false
                }
            ]
        },
        label: "Police Record",
        text: "Have you received a formal police caution in the last 5 years, ever been convicted or have any prosecutions pending",
        model: "needs"
    }
}
export function policeRecordDetails(props) {
    return {
        label: "Police Record Details",
        text: "Supply some details about this police record",
        name: "policeRecordDetails",
        answer: {
            type: "textarea"
        },
        hides: {
            policeRecord: (v) => {
                return v !== true
            }
        },
        model: "needs"
    }
}
export function incomeChange(props) {
    return {
        name: "incomeChange",
        answer: {
            type: "choice",
            choices: [
                {
                    text: "Yes",
                    value: true
                },
                {
                    text: "No",
                    value: false
                }
            ]
        },
        label: "Income Change",
        text: "Might your income change in the foreseeable future?",
        model: "needs"
    }
}
export function expenditureChange(props) {
    return {
        name: "expenditureChange",
        answer: {
            type: "choice",
            choices: [
                {
                    text: "Yes",
                    value: true
                },
                {
                    text: "No",
                    value: false
                }
            ]
        },
        label: "Expenditure Change",
        text: "Might your expenditure change significantly in the foreseeable future?",
        model: "needs"
    }
}
export function moveLikely(props) {
    return {
        name: "moveLikely",
        answer: {
            type: "choice",
            choices: [
                {
                    text: "Yes",
                    value: true
                },
                {
                    text: "No",
                    value: false
                }
            ]
        },
        label: "Move Likely",
        text: "Are you likely to move property within the mortgage term?",
        model: "needs"
    }
}
export function plannedPayOff(props) {
    return {
        name: "plannedPayOff",
        answer: {
            type: "choice",
            choices: [
                {
                    text: "Yes",
                    value: true
                },
                {
                    text: "No",
                    value: false
                }
            ]
        },
        label: "Planned Payoff",
        text: "Do you have any plans to pay off some or all of the mortgage in the foreseeable future?",
        model: "needs"
    }
}
export function beyondRetirement(props) {
    return {
        name: "beyondRetirement",
        answer: {
            type: "choice",
            choices: [
                {
                    text: "Yes",
                    value: true
                },
                {
                    text: "No",
                    value: false
                }
            ]
        },
        label: "Term Exceeds Retirement",
        text: "Will the term of the mortgage extend beyond your anticipated retirement age?",
        model: "needs"
    }
}
export function speedEssential(props) {
    return {
        name: "speedEssential",
        answer: {
            type: "choice",
            choices: [
                {
                    text: "Yes",
                    value: true
                },
                {
                    text: "No",
                    value: false
                }
            ]
        },
        label: "Speed Essential",
        text: "Is speed essential to the mortgage completion?",
        model: "needs"
    }
}
export function consolidatingDebt(props) {
    return {
        name: "consolidatingDebt",
        answer: {
            type: "choice",
            choices: [
                {
                    text: "Yes",
                    value: true
                },
                {
                    text: "No",
                    value: false
                }
            ]
        },
        label: "Consolidating Debt",
        text: "Are you consolidating any additional debts as part of this mortgage?",
        model: "needs"
    }
}
export function furtherRequirements(props) {
    return {
        name: "furtherRequirements",
        answer: {
            type: "choice",
            choices: [
                {
                    text: "Yes",
                    value: true
                },
                {
                    text: "No",
                    value: false
                }
            ]
        },
        label: "Further Requirements",
        text: "Are there any further requirement or details that you would like us to record?",
        model: "needs"
    }
}
export function furtherRequirementsDetails(props) {
    return {
        label: "Further Requirement Details",
        text: "Supply some details about this",
        name: "furtherRequirementsDetails",
        answer: {
            type: "textarea"
        },
        hides: {
            furtherRequirements: (v) => {
                return v !== true
            }
        },
        model: "needs"
    }
}